module.exports = __webpack_public_path__ + "img/schnittkante_gelb_candy.76e6dd13.jpg";